export const ZoneModel = {
    id: "",
    name: "",
    description: "",
    polylines: [],
};
